"use client";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "../../../components/navbar";
import { Footer } from "../../../components/footer";
import StatsCard from "../../../components/stats-card";
import styles from "../css/Analytics.module.css";

export default function Analytics() {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <div className={styles.app}>
      <div className={styles.mainContainer}>
        <Navbar backTo="/dashboard" />

        <div className={styles.contentAreaFull}>
          <section className={styles.panel}>
            <div className={styles.grid}>
              <StatsCard
                title="Descriptive"
                icon="bar-chart-3"
                variant="square"
                onClick={() => handleCardClick("/analytics/drug-stock-level")}
                interactive={true}
              />
              <StatsCard
                title="Predictive"
                icon="repeat"
                variant="square"
                onClick={() => handleCardClick("/analytics/demand-forecasting")}
                interactive={true}
              />
              <StatsCard
                title="Pre-emptive"
                icon="alert"
                variant="square"
                interactive={true}
              />
              <StatsCard
                title="Prescriptive"
                icon="info"
                variant="square"
                interactive={true}
              />
            </div>
          </section>
        </div>

        <div className={styles.footerWrapper}>
          <Footer />
        </div>
      </div>
    </div>
  );
}
